import styled from 'styled-components';
import { Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
export const ManageUsersWrapper = styled(Box)`
font-family: "Noto Sans", sans-serif;
  margin-top: 48px;
    margin-top: 10px;
    margin-bottom:40px;
    .usersTable {
      padding: 10px 0px 0px 30px;
      .buttonTab {
        font-family: "Noto Sans", sans-serif;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .searchbar {
          h5 {
            font-weight: 600px;
            font-size: 20px;
            color: #1b4a83;
            padding: 0 20px 0 0;
          }
          display: flex;
          align-items: center;
          .searchInput {
            width: 400px;
            background-color: #fff;
            .css-wb57ya-MuiFormControl-root-MuiTextField-root {
              display: flex;
            }
            .searchTextBox
              {
                width:100%;
              }
          }
        }
        button {
          padding: 6px 25px;
          text-transform: capitalize;
          font-size: 14px;
          font-family: "Noto Sans", sans-serif;
        }
        display: flex;
        align-items: center;
      }
      div {
        border-radius: 5px !important;
        table {
          border: 1px solid #1b4a83;
          font-size:14px;
          font-family: "Noto Sans", sans-serif;
          thead {
            background-color: #1b4a83;
            tr {
              th {
                font-weight: 600;
                color: #fff;
              }
            }
            .css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active
              .MuiTableSortLabel-icon {
              opacity: 1;
              color: #fff;
            }
            .MuiTableSortLabel-icon {
              opacity: 1;
              color: white;
              font-size: 20px;
            }
          }
          tbody {
            .link
            {
              color:#1b4a83;
              cursor:pointer
            }
          }
        }
      }
    }
  


`;
export const PaginationBox = styled(Box)`

    display: flex;
    justify-content: space-between;
    align-items: center;
    h6 {
      color: #1b4a83;
      font-weight: 600;
  
      span {
        font-size: 14px;
        font-weight: 500;
        font-family: "Noto Sans", sans-serif;
        color: #000;
        padding-left: 6px;
      }
    }
    button {
      margin: 10px 0;
      border-radius: 2px;
    }
    .paginationContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      h6 {
        color: #1b4a83;
        font-weight: 600;
        font-family: 'Noto Sans', sans-serif;
        span {
          font-size: 14px;
          font-weight: 500;
          color: #000;
          font-family: 'Noto Sans', sans-serif;
          padding-left: 6px;
        }
      }
      button {
        margin: 10px 0;
        border-radius: 2px;
      }
    }
   
`;
export const ActionBoxWrapper = styled(Box)`
button {
  padding: 0px;
  color: #1b4a83;
}
svg {
  margin: 0 10px 0 0;
  font-size: 20px;
}

`;

export const ViewPrivilegesWrapper = styled(Dialog)`
height:100%;
.css-twia2z-MuiPaper-root-MuiDialog-paper{
  max-width:70%;
  width:fit-content;
  min-width:444px
}
.customDialogTitle {
  background-color: #1b4a83;
  text-align: center;
  color: #fff;
  font-size:14px;
}
.customDialog {
  text-align: center;
  color: #000;
  .roleBox {
    h5 {
      font-weight: 600px;
      font-size: 14px;
      color: #1b4a83;
      //padding: 0 20px 0 0;
    }
  }
  ul
  {
    list-style-type:none;
    font-size: 13px;
    padding:0px;
  }
  .customDropdown {
    text-align: left;
    width: 90%;
    padding-top: 10px;
  }
  span.error {
    color: #d32f2f;
    line-height: 2;
    font-weight: 400;
  }
  span.red {
    color: #ff0000;
  }
  .errorInput {
    border: 1px solid #ff0000;
    border-radius: 5px;
  }
  .inputform {
    width: 100%;
    padding-top: 10px;
    .formValue {
      width: 90%;
    }
  }
}
.dialogbutton {
  text-align: center;
  display: block;
  margin-bottom: 10px;

  .confirmButton {
    text-align: center;
    background-color: #1b4a83;
    width: 25%;
  }
  .rightButton {
    text-align: center;
    color: #1b4a83;
    width: 25%;
    border-color: #1b4a83;
  }
}
.samRecBoxData{
  border: 1px solid #8080808f;
  margin-top: 20px;
  min-height: 350px;
  max-height: 350px;
  overflow: auto;
  max-width: 700px;
  min-width: 600px;
  text-align: left;
  padding: 5px;
}
.samRecBox{
  display:flex;
}
.samRecTexaArea{
  width:550px;
  margin-top:20px;
  font-family:Noto Sans;
  resize:none;
  :disabled{
    background-color:#fff;
  }
}
     
.searchInput{
  display: flex;
  align-items: center;
  gap: 20px;
}
.MuiBackdrop-root {
    background-color: rgba(0, 0, 0, 0.1) !important;
}
    .MuiDialog-paper {
        box-shadow: none;
    }
`;
